import React from "react";
import stylePropType from "react-style-proptype";
import PropTypes from "prop-types";

const ContactSales = (props) => {
  const { children, href, ...rest } = props;
  const handleFn = (event) => {
    event.preventDefault();
    window.location = href;
  };
  return (
    <button onClick={handleFn} type="button" {...rest}>
      {children}
    </button>
  );
};

ContactSales.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  style: stylePropType,
};

ContactSales.defaultProps = {
  className: "",
  style: {},
};

export default ContactSales;
